import type { EntityId } from '@miyuki/types';

/** Puerto de generación de identificadores. */
export interface IdGenerator {
  next(): EntityId;
}

export const uuidGenerator: IdGenerator = {
  next: () => crypto.randomUUID() as EntityId,
};

/** Generador determinista para tests: `prefix-1`, `prefix-2`, ... */
export function sequentialIdGenerator(prefix = 'id'): IdGenerator {
  let counter = 0;
  return {
    next: () => `${prefix}-${++counter}` as EntityId,
  };
}
